// ===================================================================
// THIS FILE WAS AUTO GENERATED DO NOT EDIT IMPLACE
// ===================================================================
export interface CpmCQueryPaginatorConfig {
    offset?: number;
    limit?: number;
    sort?: string;
    order?: number;
    filter?: string;
    cols_to_search?: string[];
    filters_rows?: Record<string, string | number | boolean>;
}

export class CpmCQueryPaginatorConfigUtils {
    /**
     * CpmCQueryPaginatorConfig to query parameters
     * @param cpmcQueryPaginatorConfig Source paginator config
     * @returns Built query parameters
     */
    public static toQueryParams(
        cpmcQueryPaginatorConfig: CpmCQueryPaginatorConfig | null
    ): Record<string, string | number | boolean> {
        const res: Record<string, string | number | boolean> = {};

        if (cpmcQueryPaginatorConfig?.offset !== undefined) res['_of'] = cpmcQueryPaginatorConfig.offset;
        if (cpmcQueryPaginatorConfig?.limit !== undefined) res['_l'] = cpmcQueryPaginatorConfig.limit;
        if (cpmcQueryPaginatorConfig?.sort !== undefined) res['_s'] = cpmcQueryPaginatorConfig.sort;
        if (cpmcQueryPaginatorConfig?.order !== undefined) res['_or'] = cpmcQueryPaginatorConfig.order;
        if (cpmcQueryPaginatorConfig?.filter !== undefined) res['_f'] = cpmcQueryPaginatorConfig.filter;
        if (cpmcQueryPaginatorConfig?.cols_to_search && cpmcQueryPaginatorConfig?.cols_to_search.length > 0) {
            const cts = cpmcQueryPaginatorConfig.cols_to_search.filter((x) => x).join(',') || '';
            if (cts.length > 0) res['_cts'] = cts;
        }
        if (cpmcQueryPaginatorConfig?.filters_rows) {
            const fr = Object.entries(cpmcQueryPaginatorConfig.filters_rows)
                .filter((x) => x[1] !== null && x[1] !== undefined)
                .map((x) => `${x[0]}:${x[1]}`)
                .join(',');
            if (fr.length > 0) res['_fr'] = fr;
        }

        return res;
    }
}